// France
export const locale = {
  lang: 'fr',
  data: {
    mare: 'jument',
    gelding: 'hongre',
    stallion: 'male',
    maintenance: {
      title: 'Maintenance',
      message:
        'Notre site web est actuellement en maintenance. Veuillez revenir plus tard. Merci pour votre compréhension.',
    },
    GENERAL: {
      RACES: 'Courses',
      DELETE: 'Placer le pari',
      ONE_MOMENT: 'Chargement...',
      CLOSE: 'Fermer',
      PRINT: 'Imprimer',
      RESULT: 'Rapport',
      TEMPORARY_RESULT: 'Résultat temporaire',
      BACK_BUTTON: 'Back',
      PRIVACY: 'Privacy',
      LEGAL: 'Legal',
      CONTACT: 'Contact',
      SELECT: 'choisissez votre langue',
      LANGUAGE: 'Langue',
    },
    BETTING_SLIP: {
      YOUR_BETTING_SLIP: 'Votre bulletin de pari',
    },
    MENU: {
      HOME: 'ACCUEIL',
      ALL_RACES: 'COURSES MONDIALES',
      ALL_RACES_SHORT: 'MONDIALE',
      PMU_RACES: 'COURSES PMU',
      PMU_RACES_SHORT: 'PMU',
      NEXT_RACES: 'COURSES SUIVANTES',
      NEXT_RACES_SHORT: 'DÉPART',
      STREAMING: 'Live Streaming',
    },
    HOME: {
      CALENDAR: 'Calendrier',
      TODAY: "Aujourd'hui",
      YESTERDAY: 'Hier',
      TOMORROW: 'Demain',
      COUNTRIES: 'Pays',
      NEXT_BETTING: 'Prochaines chances',
      NEXT_PMU_BETTING: 'Prochaines courses PMU',
      MORE: 'Voir plus',
      JACKPOT: 'Jackpot',
      ACCUMULATOR_TITLE: 'Bet Box/pari accumulateur',
      ACCUMULATOR_DESC:
        'Aucun cheval sélectionné pour le pari accumulateur. Cliquez sur la cote de la course.',
      STARTER_SEARCH: 'Recherche de départ',
      SEARCH: 'Rechercher',
      HEAD_TO_HEAD: 'Tête à Tête',
      HEAD_TO_HEAD_DESC:
        "Il n'y a pas d'appariement Tête à Tête disponible aujourd'hui.",
      HIGHLIGHTS: 'Faits marquants',
      STARTER_INDEX: 'Index de démarrage',
      LOGIN: 'CONNEXION',
      LOGOUT: 'Déconnexion',
      STARTING: 'Départ de la course...',
      STARTING_SHORT: 'Départ..',
      IN: 'dans',
      MAINTANANCE:
        'NOTRE PLATEFORME SERA INDISPONIBLE LE MARDI 08/11/2022, ENTRE 23:00 - 02:00 CEST EN RAISON DE MAINTENANCE',
      NOT_SHOW: 'Ne plus afficher.',
    },
    RACES: {
      MANUALREVIEW: 'Revue manuelle',
      CANCELREASON: 'Motif dannulation',
      COMBINAISON: 'Combinaison',
      PRIZE_MONEY: 'Allocation',
      DISTANCE: 'Distance',
      SOIL: 'Sol',
      STARTERS: 'Partants',
      RESULT: 'Rapport',
      STARTED: "C'est parti",
      BETTING_SLIP: 'Réf',
      START_TYPE: 'Type de départ',
      NON_STARTERS: 'Non-partants',
      TYPE_OF_BET: 'Type de Pari',
      STAKES: 'Mise',
      STAKE: 'Mise',
      TIME_RACE: 'Heure/Course',
      MARKINGS: 'Sélectionné(s)',
      EV: 'Cote',
      WIN: 'Gagnant',
      BET: 'Pari',
      NEW: 'Nouveau',
      NUMBER_OF_BETS: 'Nombre de paris',
      PLACE_BET: 'Placer le pari',
      PLACE_BET_PRINT: 'Date',
      PAY_FOR_BET: 'Confirmer',
      CONFIRM_TEXT: 'Le coût total du pari est de',
      POTENTIAL_WINNINGS: 'Gains potentiels',
      TOTAL_STAKES: 'Total des mises',
      TOTAL_PRICE: 'Prix total',
      STAKES_IN: 'Mise en',
      RACING_CLUB: 'Courtier de pari',
      MORE_BOOKIE_BETS: 'Courtier de pari',
      BOOKMAKER: 'Pari bookie',
      FIXED_ODDS_BET: 'Pari à cote fixe',
      SHOW_BETTING_SLIP: 'Afficher le ticket de pari',
      HIDE_BETTING_SLIP: 'Cacher le ticket de pari',
      MY_BETS: 'Mes paris',
      WINNINGS: 'Gains',
      TOP_WINNINGS: 'Gagnants du jour',
      NUMBER: 'Numéro',
      OPEN: 'Ouvert',
      LOST: 'Perdu',
      WON: 'Gagné',
      CANCELED: 'Annulé',
      STATUS: 'Statut',
      HORSE: 'Cheval',
      FORM: 'Forme',
      WEIGHT: 'Poids',
      TRAINER: 'Entraîneur',
      SP: 'Cote',
      FIXED_ODDS: 'Cote fixe',
      ORIGIN: 'Origines',
      LINEAGE: 'Lignée',
      OWNER: 'Propriètaire',
      AGE: 'Age',
      JOCKEY: 'Jockey',
      PLACE: 'Place',
      TOTAL: 'Total',
      TOTAL_WON: 'Gain Totale',
      TOTAL_LOST: 'Perte Totale',
      TOTAL_BETS: 'Total des paris',
      TOTAL_CANCELED: 'Total annulé',
      TOTAL_REFUND: 'Total remboursé',
      TOTAL_CASHBACK: 'Total Cashback',
      DATE: 'Date',
      RACE: 'Course',
      RACE_C: 'C',
      RACE_LOCATION: 'Réunion',
      BET_TYPES: 'Types de pari',
      CONFIRM_YOUR_BET: 'Confirmer votre Pari',
      GO_TO_RACE: 'Allez à la course',
      DOG: 'Chien',
      DRIVER: 'Conducteur',
      RECORD_TIME: 'Temps record',
      NO_OF_STARTS: 'Nb de démarrages',
      NO_OF_WINS: 'Nbre de victoires',
      NO_OF_PLACES: 'Nbre de places',
      QUINELLA: 'Jumelé',
      SWINGER: 'Jumelé placé',
      QUINELLA_SWINGER: 'Jumelé/Jumelé placé',
      EXACTA: 'Couplé',
      QUINTE: 'Quinte+ Champ',
      'QUINTÉ+': 'Quinte+',
      'QUINTÉ+_7': 'Quinte Ordre',
      'QUINTÉ+_6': 'Quinte Désordre',
      'QUINTÉ+_4': 'Quinte Ordre',
      'QUINTÉ+_3': 'Quinte Ordre',
      'QUINTÉ+_2': 'Quinte Désordre',
      'QUINTÉ+_1': 'Quinte Bonus 4',
      'QUINTÉ+_0': 'Quinte Bonus 3',
      QUINTE_STANDARD: 'Quinte Standard',
      TRIFECTA: 'Trifecta',
      TIERCE: 'Tiercé Champ',
      'TIERCÉ_-1': 'Tiercé Champ',
      TIERCÉ: 'Tiercé',
      TIERCÉ_1: 'Tiercé Ordre',
      TIERCÉ_0: 'Tiercé Désordre',
      TIERCE_STANDARD: 'Tiercé Standard',
      'TIERCÉ STANDARD': 'Tiercé Standard',
      'TIERCÉ CHAMP_0': 'Tiercé Désordre',
      'TIERCÉ CHAMP_1': 'Tiercé Ordre',
      QUARTE: 'Quarté Champ',
      'QUARTÉ+': 'Quarté+',
      'QUARTÉ+_-1': 'Quarté Champ',
      'QUARTÉ+_2': 'Quarté Ordre',
      'QUARTÉ+_1': 'Quarté Désordre',
      'QUARTÉ+_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_1': 'Quarté Désordre',
      'QUARTÉ+ CHAMP_2': 'Quarté Ordre',
      'QUARTÉ+ STANDARD': 'Quarté Standard',
      QUARTE_STANDARD: 'Quarté Standard',
      WIN_PLACE: 'Gagnant/Place',
      AMOUNT: 'Montant',
      BALANCE: 'Solde',
      PROFIT_FROM_BETTING: 'Gains',
      DEPOSIT: 'Dépôt',
      WITHDRAWAL: 'Retrait',
      REFUND: 'Remboursé',
      CANCEL: 'Annulé',
      CASHBACK: 'Remise en Argent',
      FINISH: 'Terminé',
      RACE_NR: 'Course',
      RACE_NR_C: 'C',
      ODDS: 'Cotes',
      R: 'C',
      ALL: 'Tous',
      CANCELLATIONS: 'Annulations',
      BETS: 'Paris',
      NOT_FOUND_RACE: 'Course Non Trouvée',
      CURRENT_FIXED_ODDS: 'Cotes fixes actuelles',
      J: 'ans.',
      MARE: 'jument',
      STALLION: 'male',
      GELDING: 'hongre',
      T: 'E',
      NO_BET: "Vous n'avez pas encore parié sur cette course",
      CANCEL_COUPON: 'Annuler le coupon',
      COUPON_CANCELLED_MESSAGE: '{{betSlipId}} a été annulé avec succès',
      COUPON_CANCELLED_ERROR_MESSAGE:
        "La limite d'annulation du coupon a été dépassée",
      SHOW_CHAT: 'Afficher le chat',
      HIDE_CHAT: 'Cacher le chat',
      STARTING: 'Départ',
    },
    AUTH: {
      GENERAL: {
        OR: 'Ou',
        SUBMIT_BUTTON: 'Soumettre',
        NO_ACCOUNT: 'Ne pas avoir de compte?',
        SIGNUP_BUTTON: 'Registre',
        FORGOT_BUTTON: 'Mot de passe oublié',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        MY_ACCOUNT: 'Mon Compte',
      },
      MENU: {
        ACCOUNT: 'Compte',
        BETS: 'Paris',
        PROFILE: 'Profil',
      },
      ACCOUNT: {
        YOUR_CURRENT_ACCOUNT: 'Transaction du compte à partir de {{date}}',
        RECENT_TRANSACTIONS: 'Transactions récentes sur votre compte de paris.',
        ANY_TRANSACTION: "Vous n'avez pas de transaction.",
        AVAILABLE_FOR_WITHDRAWAL: 'Disponible pour le retrait',
      },
      BET: {
        NO_BET_HISTORY:
          "Aucun historique des paris n'est actuellement disponible.",
      },
      ACTIVATION: {
        TITLE: 'Activation Complète',
        PASSWORD_REQUIRED: 'Veuillez changer le mot de passe.',
        EMAIL_OPTIONAL:
          "L'adresse électronique est optionnelle, mais nous vous recommandons vivement de saisir et d'activer l'adresse électronique que vous utilisez activement. ",
        COMPLETE: 'Activez',
      },
      LOGIN: {
        TITLE: 'Créer un compte',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        FORGOT_PASSWORD: 'Vous avez oublié votre mot de passe?',
        RESET_PASSWORD: 'Réinitialiser le mot de passe',
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        USERNAME: "Nom d'utilisateur",
        FULLNAME: 'Fullname',
        PASSWORD: 'Mot de passe',
        CONFIRM_PASSWORD: 'Confirm Password',
        NEW_PASSWORD: 'Nouveau mot de passe',
        CONFIRM_NEW_PASSWORD: 'Confirmer le nouveau mot de passe',
        EMAIL: 'Adresse e-mail',
        CONFIRM_EMAIL: "Confirmer l'adresse e-mail",
      },
      VALIDATION: {
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Obligatoire',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        USER_ACCOUNT_UPDATED: 'User account has been successfully updated',
      },
    },
    ALERT: {
      SUCCESSFULLY_CREATED: 'Le pari a été créé avec succès',
      USERNAME_NOTFOUND: "Nom d'utilisateur introuvable",
      USERNAME_OR_PASSWORD_IS_INCORRECT:
        "Nom d'utilisateur ou le mot de passe est incorrect. Veuillez réessayer.",
      PASSWORD_IS_INCORRECT:
        'Le mot de passe est incorrect. Veuillez réessayer.',
      PASSWORD_MUST_MATCH: 'Les mots de passe doivent correspondre',
      ONLY_VALID_BETS_ARE_ALLOWED: 'Seuls les paris valides sont autorisés',
      RACE_IS_STARTED: 'Pari fermé',
      STAKE_ERROR: 'Stake error',
      INSUFFICIENT_BALANCE: 'Solde insuffisant',
      USER_ACCOUNT_UPDATED: 'User account has been successfully updated',
      SOMETHING_WENT_WRONG: 'Veuillez réessayer',
      USER_PASSWORD_UPDATED:
        "Le mot de passe de l'utilisateur a été mis à jour avec succès",
      PASSWORD_SUCCESSFULLY_RESET: 'Your password was successfully reset',
      ACTIVATION_SUCCESSFULLY_COMPLETE_EMAIL:
        "L'activation de l'utilisateur a été effectuée avec succès. Veuillez vérifier votre adresse e-mail",
      ACTIVATION_SUCCESSFULLY_COMPLETE:
        'User activation has been successfully complete',
      MUST_BE_FILLED_CORRECTLY: '{{invalids}} must be filled correctly!',
      VERIFY_YOUR_EMAIL: 'Please verify your email address',
      WELCOME: 'Welcome',
      EMAIL_SUCCESSFULLY_VERIFIED: 'Your email was successfully verified.',
      MONEY_HAS_BEEN_DEPOSITED: 'Money has been deposited into your account.',
      Please_refresh_the_page_to_print:
        'Veuillez actualiser la page pour imprimer.',
      OUT_OF_ORDER: 'Votre compte a été temporairement désactivé.',
    },
    TRACK_RACES: {
      YEARS_OLD_HORSES: 'Pour chevaux de {{year}} ans',
      YEARS_OLD_AND_UPWARD_HORSES: 'Pour chevaux de {{year}} ans et plus',
    },
    QUARTE_RACES: {
      HEADER_TITLE: 'Quarté du jour',
      FINISHED: 'Terminée',
      NO_RACE: "N'existe pas encore",
    },
    Next_Races_Seo: {
      title: 'Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Retrouvez la liste des prochaines courses disponibles...',
      keywords_content: 'PROCHAINE OPPORTUNITÉ DE PARI',
    },

    HomePage_Seo: {
      title: 'Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        "La destination ultime en ligne pour les paris hippiques dans le monde entier ! Nous offrons une large gamme de types de paris pour les événements de courses de chevaux, ainsi qu'un cashback qui garantit votre satisfaction. Rejoignez Racebet365.com aujourd'hui et découvrez le frisson des paris hippiques en ligne comme jamais auparavant !",
      keywords_content:
        'Paris hippique en ligne, Parier sur les courses hippiques, Site de paris en ligne, Jeu de course de chevaux, Courses hippiques dans monde entier, Courses PMU',
    },

    All_Races_Seo: {
      title:
        'Courses Mondiales | Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Découvrez toutes les courses mondiales et placez vos paris sur Racebet365 ! Nous proposons une large sélection de courses, des courses hippiques aux courses de chiens.',
      keywords_content:
        'courses, courses de chevaux, courses de chiens, Racebet365, paris, Royaume-Uni, États-Unis, Australie, courses populaires, combinaisons, courses mondiales.',
    },

    Pmu_Races_Seo: {
      title: 'Courses PMU | Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Découvrez les courses PMU et placez vos paris sur Racebet365! Des courses passionnantes vous attendent avec des combinaisons de paris comme Gagnant, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce et Quatre.',
      keywords_content:
        'PMU, course, Racebet365, pari, Gagnant, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce, Quatre.',
    },

    Next_Betting_Seo: {
      title:
        'Courses Suivantes | Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Ne manquez pas les courses suivantes sur Racebet365 ! Avec nos paris 24/7, vous pouvez suivre des courses du monde entier et placer vos paris sur vos courses préférées.',
      keywords_content:
        'courses suivantes, courses, Racebet365, paris, monde entier, 24/7, suivi, courses favorites.',
    },

    Track_Races_Seo: {
      description_content: ' Retrouvez la liste des courses disponibles dans ',
      keywords_content: 'COURSES VINCENNES ',
    },

    Account_Page_Seo: {
      description_content: 'Consulter l historique de vos transactions',
      keywords_content: 'HISTORIQUE DES TRANSACTIONS',
    },

    Profile_Page_Seo: {
      description_content:
        'Vérifiez les informations de votre compte, changez le mot de passe.',
      keywords_content: 'MON PROFILE',
    },
    Bets_Page_Seo: {
      description_content: 'Consulter votre historique de paris',
      keywords_content: 'HISTORIQUE DES PARIS',
    },
    'Some coupons gave an error': 'Certains coupons ont donné une erreur',
    'Something went wrong.': "Quelque chose s'est mal passé.",
    'Only valid bets are allowed': 'Seuls les paris valides sont autorisés',
    'Total price error': 'Erreur de prix total',
    'Coupon was lost.': 'Le coupon a été perdu.',
    'Insufficient balance': 'Solde insuffisant',
    CRYPTO: {
      ONLY_SEND_TETHER_USDT: "Envoyez UNIQUEMENT Tether (USDT)",
      TO_THIS_DEPOSIT_ADDRESS: "à cette adresse de dépôt",
      DO_NOT_USE: "N'utilisez PAS",
      DO_NOT_USE_ERC20: "ERC20, BEP2, BEP20, OMNI, SOL, ou d'autres standards de réseau car vous pourriez perdre votre dépôt.",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK_ERC20: "Effectuez UNIQUEMENT des dépôts via le réseau Ethereum (ERC20)",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK: "Effectuez UNIQUEMENT des dépôts via le réseau Ethereum",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_TRON_TRC20_NETWORK: "Effectuez UNIQUEMENT des dépôts via le réseau Tron (TRC20).",
      DO_NOT_USE_BEP2_BEP20_OMNI_TRC20_SOL: "BEP2, BEP20, OMNI, TRC20, SOL ou d'autres standards de réseau car vous pourriez perdre vos fonds.",
      DO_NOT_USE_BEP2_BEP20: "BEP2, BEP20, ou d'autres standards de réseau car vous pourriez perdre votre dépôt.",
      THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED: "L'utilisation d'adresses de contrat n'est pas autorisée.",
      ONLY_SEND_ETHEREUM_METH: "Envoyez UNIQUEMENT Ethereum (mETH)",
      ONLY_SEND_BITCOIN_MICRONBTC: "Envoyez UNIQUEMENT Bitcoin (µBTC)",
      DO_NOT_USE_LIGHTNING_NETWORK: "Lightning Network, BEP20, BEP2, ERC20, Polygon ou d'autres standards de réseau car vous pourriez perdre votre dépôt.",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_BTC_NETWORK: "Effectuez UNIQUEMENT des dépôts via le réseau BTC.",
      SELECT_YOUR_CRYPTO_CURRENCY_DEPOSIT_METHOD: 'Sélectionnez votre méthode de dépôt de crypto-monnaie',
      RISKS_CONFIRMATION: "En cliquant sur le bouton 'Confirmer', vous indiquez que vous acceptez les risques mentionnés ci-dessus.",
      DEPOSIT: "Dépôt",
      WITHDRAWAL: "Retrait",
      COPY_ADDRESS_OR_SCAN_QR_CODE: 'Copier l adresse ou scanner le QR Code',
      MINIMUM_DEPOSIT_AMOUNT: 'Montant minimum de dépôt {{amount}}',
      NOTE_ABOUT_THE_EXCHANGE_RATE: 'Note sur le taux de change: Veuillez noter que le taux de change à la fin de la transaction peut différer légèrement du ci-dessus.',
      TRANSACTION_COMPLETION: 'Transaction terminée: Veuillez noter que après la fin d une transaction, il peut prendre jusqu à 15 minutes pour que le changement soit visible sur votre solde.',
    },
  },
 
};
